import { getContext, reset } from './web-notification-service-ctx';
import { pairDevice } from 'nike-ui/src/components/notifications/nike-notification-server-api';
import buildNotification from 'nike-ui/src/common/messaging/buildNotification';

export function rePairDevice() {
    log('(re)pair');
    pairDevice(getContext().token).catch(console.warn);
    reset();
}

export function handleMessage(payload) {
    //dostal som spravu, vytvor notifikaciu
    const { title, options } = buildNotification(payload.data);
    navigator.serviceWorker.ready.then(registration => registration.showNotification(title, options));
}

function log() {
    const args = Array.prototype.slice.call(arguments);
    args.unshift('[notifications-web]');
    console.log.apply(null, args);
}
